import router from '../index'
import store from '../../store'
import {isWechatBrowser, getAuthorizeUrl} from '../../utils/wx'
import {ROUTE_SWITCHING} from '../../store/mutation-types'

export default () => {
  router.beforeEach((to, from, next) => {
    store.commit(ROUTE_SWITCHING, true)
    if (to.matched.some(m => m.meta.auth !== false) && !store.state.auth.authenticated) {
      if (isWechatBrowser()) {
        window.location.href = getAuthorizeUrl()  // 获取微信认证地址
      } else {
        next('/login')
      }
    } else {
      next()
    }
  })
}



// WEBPACK FOOTER //
// ./src/router/setup/before.js